import React from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { AnimatedSection } from '../components/shared/AnimatedSection';
import { Target, Eye, Award, Users, Lightbulb, Shield, Leaf, CheckCircle } from 'lucide-react';
export function AboutPage() {
  const values = [{
    icon: <Shield size={32} data-id="element-272" />,
    title: 'Integrity',
    desc: 'Upholding the highest ethical standards'
  }, {
    icon: <Award size={32} data-id="element-273" />,
    title: 'Excellence',
    desc: 'Delivering superior quality in every project'
  }, {
    icon: <Lightbulb size={32} data-id="element-274" />,
    title: 'Innovation',
    desc: 'Embracing cutting-edge solutions'
  }, {
    icon: <Users size={32} data-id="element-275" />,
    title: 'Safety',
    desc: 'Prioritizing health and safety always'
  }, {
    icon: <Leaf size={32} data-id="element-276" />,
    title: 'Sustainability',
    desc: 'Building for a better tomorrow'
  }];
  const whyChooseUs = ['Experienced engineers and architects', 'Cutting-edge equipment and technology', 'Transparent processes and communication', 'Timely and cost-effective delivery', 'Advanced project management systems', 'Strong government and private sector relationships'];
  return <div className="min-h-screen pt-20" data-id="element-277">
      <SectionHeader title="About FDF Gold Concept" subtitle="Building Excellence, Engineering the Future" data-id="element-278" />

      <section className="py-20" data-id="element-279">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
          <AnimatedSection className="mb-20" data-id="element-281">
            <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-282">
              Who We Are
            </h2>
            <p className="text-stone text-lg leading-relaxed mb-4" data-id="element-283">
              FDF Gold Concept Nigeria Limited is a multidisciplinary
              construction and engineering company established in 2021. We
              specialize in delivering innovative, sustainable, and world-class
              solutions across the construction, civil engineering, and real
              estate development sectors.
            </p>
            <p className="text-stone text-lg leading-relaxed" data-id="element-284">
              With a national presence and a commitment to excellence, we have
              rapidly become a trusted partner for both government agencies and
              private sector clients, successfully completing projects worth
              over ₦500 million.
            </p>
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20" data-id="element-285">
            <AnimatedSection data-id="element-286">
              <div className="bg-gradient-to-br from-gold/10 to-transparent p-8 rounded-lg border-l-4 border-gold" data-id="element-287">
                <Target size={48} className="text-gold mb-4" data-id="element-288" />
                <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-289">
                  Our Vision
                </h3>
                <p className="text-stone leading-relaxed" data-id="element-290">
                  To be the leading construction and engineering company in
                  Nigeria, recognized for innovation, quality, and sustainable
                  development practices.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection data-id="element-291">
              <div className="bg-gradient-to-br from-deep-blue/10 to-transparent p-8 rounded-lg border-l-4 border-deep-blue" data-id="element-292">
                <Eye size={48} className="text-deep-blue mb-4" data-id="element-293" />
                <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-294">
                  Our Mission
                </h3>
                <p className="text-stone leading-relaxed" data-id="element-295">
                  To deliver exceptional construction and engineering solutions
                  that exceed client expectations while maintaining the highest
                  standards of safety, quality, and sustainability.
                </p>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection className="mb-20" data-id="element-296">
            <h2 className="text-3xl font-bold text-charcoal mb-12 text-center" data-id="element-297">
              Our Core Values
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-298">
              {values.map((value, index) => <div key={index} className="text-center group" data-id="element-299">
                  <div className="text-gold mb-4 flex justify-center group-hover:scale-110 transition-transform" data-id="element-300">
                    {value.icon}
                  </div>
                  <h3 className="font-bold text-charcoal mb-2" data-id="element-301">
                    {value.title}
                  </h3>
                  <p className="text-stone text-sm" data-id="element-302">{value.desc}</p>
                </div>)}
            </div>
          </AnimatedSection>

          <AnimatedSection data-id="element-303">
            <h2 className="text-3xl font-bold text-charcoal mb-8" data-id="element-304">
              Why Choose Us
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-305">
              {whyChooseUs.map((reason, index) => <div key={index} className="flex items-start gap-4" data-id="element-306">
                  <CheckCircle size={24} className="text-gold flex-shrink-0 mt-1" data-id="element-307" />
                  <p className="text-stone text-lg" data-id="element-308">{reason}</p>
                </div>)}
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}